import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"

const ThankYouPage = () => (
  <Layout>
    <Seo title="Thank you!" />
    <div className="page-content bg-light">
      <div className="container">
        <div className="pt-5 text-center">
          <h1 className="text-muted text-uppercase">Thank you!</h1>
          <p>We have received your message and will get back to you shortly.</p>
          <Link className="btn btn-primary m-2" role="button" to="/">
            Take Me Home
          </Link>
        </div>
      </div>
    </div>
  </Layout>
)

export default ThankYouPage
